import { SupplierCard_CreateAdVariationMutation, SupplierCard_CreateAdVariationMutationVariables, SupplierCard_CreateVariationTypeMutation, SupplierCard_CreateVariationTypeMutationVariables, SupplierCard_CreateVariationTypeValueMutation, SupplierCard_CreateVariationTypeValueMutationVariables, SupplierCard_LinkAdVariationToSupplierProductVariationMutation, SupplierCard_LinkAdVariationToSupplierProductVariationMutationVariables, SupplierCard_LinkAdVariationToTypeValueMutation, SupplierCard_LinkAdVariationToTypeValueMutationVariables, SupplierCard_SupplierProductFragment, SupplierCard_UnlinkAdVariationFromSupplierProductVariationMutation, SupplierCard_UnlinkAdVariationFromSupplierProductVariationMutationVariables, SupplierCard_UnlinkAdVariationFromTypeValueMutation, SupplierCard_UnlinkAdVariationFromTypeValueMutationVariables, SupplierCard_UpdateAdVariationTypeValueMutation, SupplierCard_UpdateAdVariationTypeValueMutationVariables, SupplierCard_UpdateAdVariationTypeMutation, SupplierCard_UpdateAdVariationTypeMutationVariables, SupplierCard_UpdateVariationTypeValueMediasMutation, SupplierCard_UpdateVariationTypeValueMediasMutationVariables } from "../../../../codegen/graphql"
import { gql } from "@apollo/client"
import graphqlClient from "../../../graphqlClient"
import { uploadImages } from "../../../utils/imageApi"
import { toast } from "react-toastify"


export default async function SupplierCard_importVariations(
  adId: string,
  supplierProduct: SupplierCard_SupplierProductFragment,
  mappings: any[]
) {
  try {
    // Maps supplier type value ids to the created ad type value ids
    const variationTypeValues: any = {}
    
    // Create variation types and values based on mappings
    for (const mapping of mappings) {
      if (mapping.ignore) continue;

      const valuesToCreate = mapping.values.filter((value: { skip: boolean }) => !value.skip);
      if (valuesToCreate.length === 0) continue;

      // Create variation type
      const createAdVariationTypeResponse = await graphqlClient.mutate<
        SupplierCard_CreateVariationTypeMutation,
        SupplierCard_CreateVariationTypeMutationVariables
      >({
        mutation: CREATE_VARIATION_TYPE,
        variables: {
          input: {
            adId,
            type: mapping.typeName,
          }
        }
      })
      
      const variationTypeId = createAdVariationTypeResponse.data!.createAdVariationType.id

      // Create variation type values
      for (const value of valuesToCreate) {
        const createAdVariationTypeValueResponse = await graphqlClient.mutate<
          SupplierCard_CreateVariationTypeValueMutation,
          SupplierCard_CreateVariationTypeValueMutationVariables
        >({
          mutation: CREATE_VARIATION_TYPE_VALUE,
          variables: {
            input: {
              typeId: variationTypeId,
              value: value.typeValueName,
            },
          }
        })

        const variationTypeValueId = createAdVariationTypeValueResponse.data!.createAdVariationTypeValue.id
        variationTypeValues[value.propertyValueId] = variationTypeValueId

        // Upload and link image if available
        if (value.propertyValueImage) {
          const imageUrl = value.propertyValueImage
          const imageResponse = await fetch(imageUrl, {
            referrerPolicy: 'no-referrer',
          })
          const imageBlob = await imageResponse.blob()
          const imageFile = new File([imageBlob], 'image.jpg', { type: 'image/jpeg' })
          const uploadedImagesResponse = await uploadImages([imageFile], adId, [])
          const uploadedImages = await uploadedImagesResponse.json()
          const uploadedImage = uploadedImages[0]
          
          await graphqlClient.mutate<
            SupplierCard_UpdateVariationTypeValueMediasMutation,
            SupplierCard_UpdateVariationTypeValueMediasMutationVariables
          >({
            mutation: UPDATE_VARIATION_TYPE_VALUE_MEDIAS,
            variables: {
              id: variationTypeValueId,
              input: { mediaIds: [uploadedImage.id] }
            },
          })
        }
      }
    }

    // Create ad variations and link them
    for (const variation of supplierProduct.variations) {
      let properties = variation.typeValues
      if (properties === undefined || properties.length === 0) continue;

      let exclude = false;
      const typeValueIds: string[] = [];

      for (const property of properties) {
        const mapping = mappings.find((item) => item.skuPropertyId === property.type.id);
        const valueMapping = mapping?.values.find((value: { propertyValueId: string }) => value.propertyValueId === property.id);

        if (!mapping || !valueMapping || valueMapping.skip) {
          exclude = true;
          break;
        }

        if (!mapping.ignore) {
          const typeValueId = variationTypeValues[property.id];
          if (!typeValueId) {
            exclude = true;
            break;
          }
          typeValueIds.push(typeValueId);
        }
      }

      if (exclude) continue;

      // Create ad variation
      const createAdVariationResponse = await graphqlClient.mutate<
        SupplierCard_CreateAdVariationMutation,
        SupplierCard_CreateAdVariationMutationVariables
      >({
        mutation: CREATE_AD_VARIATION,
        variables: {
          input: {
            adId,
          }
        }
      })

      const adVariationId = createAdVariationResponse.data!.createAdVariation.id;

      // Link supplier product variation
      await graphqlClient.mutate<
        SupplierCard_LinkAdVariationToSupplierProductVariationMutation,
        SupplierCard_LinkAdVariationToSupplierProductVariationMutationVariables
      >({
        mutation: LINK_AD_VARIATION_TO_SUPPLIER_PRODUCT_VARIATION,
        variables: {
          adVariationId,
          supplierProductVariationKeys: [{
            sku: variation.sku,
            supplierProductId: variation.supplierProductId,
          }],
        }
      })

      if (typeValueIds.length === 0) continue;

      await graphqlClient.mutate<
        SupplierCard_LinkAdVariationToTypeValueMutation,
        SupplierCard_LinkAdVariationToTypeValueMutationVariables
      >({
        mutation: LINK_AD_VARIATION_TO_TYPE_VALUE,
        variables: {
          adVariationId,
          typeValueIds,
        }
      })
    }

    toast.success('Variations importées avec succès')
  } catch (error) {
    console.error('Error importing variations:', error)
    toast.error('Erreur lors de l\'importation des variations')
  }
}



/*
 * Type values
 */
const UPDATE_VARIATION_TYPE_VALUE_MEDIAS = gql`
  mutation SupplierCard_UpdateVariationTypeValueMedias($id: ID!, $input: UpdateVariationTypeValueMediasInput!) {
    updateVariationTypeValueMedias(id: $id, input: $input) {
      id
      medias {
        id
        url
      }
    }
  }
`;


const CREATE_VARIATION_TYPE_VALUE = gql`
  mutation SupplierCard_CreateVariationTypeValue($input: CreateAdVariationTypeValueInput!) {
    createAdVariationTypeValue(input: $input) {
      id
      value
      leboncoinData
      variations {
        id
      }
    }
  }
`;

/*
 * Variations
 */
const CREATE_AD_VARIATION = gql`
  mutation SupplierCard_CreateAdVariation($input: CreateAdVariationInput!) {
    createAdVariation(input: $input) {
      id
    }
  }
`;


const CREATE_VARIATION_TYPE = gql`
  mutation SupplierCard_CreateVariationType($input: CreateAdVariationTypeInput!) {
    createAdVariationType(input: $input) {
      id
      type
      leboncoinData
      typeValues {
        id
        value
        leboncoinData
      }
    }
  }
`;


const LINK_AD_VARIATION_TO_SUPPLIER_PRODUCT_VARIATION = gql`
  mutation SupplierCard_LinkAdVariationToSupplierProductVariation($adVariationId: ID!, $supplierProductVariationKeys: [SupplierProductVariationCompositeKey!]!) {
    link_AdVariation_SupplierProductVariation(adVariationId: $adVariationId, supplierProductVariationKeys: $supplierProductVariationKeys) {
      id
    }
  }
`;


const LINK_AD_VARIATION_TO_TYPE_VALUE = gql`
  mutation SupplierCard_LinkAdVariationToTypeValue($adVariationId: ID!, $typeValueIds: [ID!]!) {
    link_AdVariation_TypeValue(adVariationId: $adVariationId, typeValueIds: $typeValueIds) {
      id
      variationTypeValues {
        id
        value
        type {
          id
          type
        }
      }
    }
  }
`;